import { WindTurbineMarker } from "./WindTurbineMarker";
export default WindTurbineMarker;
